import MarketDescriptionMapper from './market-description-mapper';

const MarketDescriptionModel = {
    mapper: MarketDescriptionMapper,

    id: {
        type: String,
    },

    labels: {
        type: Object,
    },

    names: {
        type: Object,
    },

    outcomes: {
        type: Array,
    },

    priority: {
        type: Boolean,
    },

    specifiers: {
        type: Array,
    },
};

export default MarketDescriptionModel;
